import React from 'react';
import { Icon } from '@hz-design-system/web-ui';
import Classes from '../ProfileSidebar.module.scss';

const LocationInfo = ({ sellerAddress }: { sellerAddress: { street: string; postCode: string; city: string } }) => (
  <div className={Classes.locationWrap}>
    <Icon name="location" className={Classes['locationWrap-icon']} />
    <div className={Classes.sellerAddress}>
      <span>{sellerAddress.street}</span>
      <span>{`${sellerAddress.postCode} ${sellerAddress.city}`}</span>
    </div>
  </div>
);

export default LocationInfo;
